import { useEffect, useRef } from 'react';

import { useLocation } from 'js/lib/useRouter';

import { CareerIcon } from 'bundles/search-common/constants/autocomplete';
import { saveRecentlyViewed } from 'bundles/search-common/utils/SearchUtils';

export type RecentlyViewedData = {
  name?: string | null;
  slug?: string;
  photoUrl?: string;
  id?: string;
};

const useLogRecentlyViewed = ({ name, slug, id }: RecentlyViewedData) => {
  const hasRunSave = useRef(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (id && name && !hasRunSave.current) {
      saveRecentlyViewed({
        id,
        name,
        path: pathname,
        imageIconWithSize: CareerIcon,
        slug,
        productType: 'SKILL_CAREERROLE',
      });
      hasRunSave.current = true;
    }
  }, [id, name, pathname, slug]);
};

export default useLogRecentlyViewed;
